import { Component, OnInit } from '@angular/core';
import { Carrier } from '../carrier/carrier';
import { CarrierSearchService } from './carrier-search.service';
import { ErrorHandler } from "../utils/error-handler"
import { Message, LazyLoadEvent, SelectItem } from 'primeng/api';
import { MessagesService } from '../messages/messages.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { PrintRequest } from '../carrier/print-request';
import { saveAs as saveByFileSaver } from "file-saver";
import { Container } from '../container-view/models/container';
import { ContainerUtility } from '../utils/container-utility';
import { ContainerType } from '../container-view/models/container-type-enum';
import { Printer } from '../masterdata/models/printer';
import { CarrierState } from '../masterdata/models/carrierState';
import { ProcessStep } from '../masterdata/models/processStep-enum';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
/* 
 * @description: This component represents Carrier Search module in GUI
 */
@Component({
  selector: 'app-carrier-tracking',
  templateUrl: './carrier-search.component.html',
  styleUrls: ['./carrier-search.component.css']
})
export class CarrierSearchComponent implements OnInit {
  selections: any;
  carriers: Carrier[];
  containers: Container[];
  // rootContainers: Container[] = null;
  searchBarcode: string;
  searchDate: string;
  display: boolean;
  selectedContainer: Container;
  containerUtil: ContainerUtility = new ContainerUtility();
  errorHandler: ErrorHandler = new ErrorHandler;
  msgs: Message[] = [];
  totalRecords: number = 0;
  pageNo: number = 0;
  loading: boolean;
  selectedLab: SelectableLab;
  isCarrier: boolean;

  printersList: Printer[];
  selectedPrinter: Printer;

  carrierStateDetails: CarrierState;
  processStep: string;

  processListObjects:CarrierState[];
  processList:SelectItem[];
  selectedStep:string;
  processStates:SelectItem[];
  wellTypes:SelectItem[];
  selectedState:string;
  selectedWellType:string;
  dateFilterDisable:boolean = true;

  /**
   * @constructor
   * @param _carrierSearch 
   * @param _messagesService 
   */
  constructor(private _carrierSearch: CarrierSearchService, private _messagesService: MessagesService, private carrierStatusService: CarrierStatusService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
  }
  blocked: boolean = false;
  hasToggle: boolean = false;

  ngOnInit() {
    this.display = false;
    this.loading = false;

    //get Sample_Reception MDM configuration
    this.processStep = ProcessStep.SAMPLE_RECEPTION;
    this.getProcessStepDetail(this.processStep);

    //get the Process Steps for selected Lab
    this.getProcessStepList();

    this.processStates=[
      {label: 'STARTED' , value : 'STARTED' },
      {label: 'COMPLETED' , value : 'COMPLETED' }
    ];

    this.wellTypes=[
      {label: '96-Well' , value : '96-Well' },
      {label: '384-Well' , value : '384-Well' },
      {label: '100-Well' , value : '100-Well' }
    ];

  }

  /**
   * @function
   * @param barcode
   * @description This method will invoke service method to bring Carrier filtered by given barcode.
  */
  searchCarrierByBarcode(barcode: string): any {
    this.totalRecords = 0;
    console.log("barcode : " + barcode);
    console.log("selected Lab : ", this.selectedLab);
    if (barcode != undefined && barcode != null && barcode != "") {
      this.searchBarcode = barcode.trim();
      this.blocked = true
      this._carrierSearch.searchContainerByBarcode(this.searchBarcode, this.selectedLab.lab).subscribe(
        results => {
          this.blocked = false
          console.log(results);
          this.totalRecords = results.data.length;
          this.containers = results.data;
          this.setReactioSetStatusForReactionPlates(this.containers);
        },
        error => {
          this.blocked = false
          console.log(error);
          let errMessage = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(errMessage);
        }
      );

    } else {
      this.carriers = [];
    }
  }

  //Set latest status of reaction sets to the plate
  setReactioSetStatusForReactionPlates(containers: Container[]){
     // loop in process Step objects
     for ( let container of this.containers) {
      //Add to the list only when process list is enabled for the step
      if(container.containerType == ContainerType.REACTIONPLATE){
         let containerItems: any = container.containerItems;
        if(containerItems.length > 0){
          for ( let item of containerItems) {
            let reactionSet:any = item.containerItemAware;
            if(reactionSet && reactionSet.state){
              container.processStep = reactionSet.state
              container.processState = "";
              break;
            }
          }
        }
      }
    }
  }

  /**
   * @function
   * @param pageNo
   * @description This method will invoke service method to bring Carrier filtered by given date.
   * This method is accessed when date filter is changed or user scrolls the records down. It uses 
   * pagination on scroll event and every request fetches 100 records at a time.  
   */
  searchBySampleCreationDate(pageNo: number): any {
    console.log("search date: " + this.searchDate + ", Page No: " + pageNo);
    if (this.searchDate != undefined && this.searchDate != null && this.searchDate != "") {
      if(!this.selectedStep) this.selectedStep = "";
      if(!this.selectedState) this.selectedState = "";
      if(!this.selectedWellType) this.selectedWellType = "";
      if (this.totalRecords == 0) {
        this._carrierSearch.getCarriersCount(this.searchDate, this.selectedLab.lab, this.selectedStep, this.selectedState,this.selectedWellType).subscribe(
          results => {
            console.log("Total Records: " + results.data);
            this.totalRecords = results.data;
            this.loading = false;
          },
          error => {
            console.log(error);
            let errMessage = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(errMessage);
            this.loading = false;
          }
        );
      }

      this.loading = true;
      this._carrierSearch.searchBySampleCreationDate(this.searchDate, this.pageNo, this.selectedLab.lab, this.selectedStep, this.selectedState, this.selectedWellType).subscribe(
        results => {
          console.log(results);
          this.containers = results.data;
          this.loading = false;
        },
        error => {
          console.log(error);
          let errMessage = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(errMessage);
          this.loading = false;
        }
      );
      this.loading = false;
    } else {
      this.loading = false;
      let message = { severity: 'error', summary: 'Invalid date', detail: 'Please enter date in dd.mm.yy format' };
      this._messagesService.addErrorMessage(message);
    }

  }

  /**
   * @function
   * @param carrier 
   * @description This method is responsible for showing Carrier Overview popup while carrier barcode
   * is clicked in filtered results.
  */
  showCarrierOverview(container: Container) {

    this._carrierSearch.getContainerById(container._id).subscribe(
      results => {
        console.log(results);
        this.selectedContainer = results.data;
        // TODO remove, as soon as carrier and container class are cleaned up
        this.selectedContainer.containerState = results.data.state;
        //////////////////////////////////////////////
        this.isCarrier = container.containerType != null ? container.containerType == ContainerType.CARRIER ? true : false : true;
        this.display = true;
      },
      error => {
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      }
    );

  }
  /**
   * @function
   * @param event: This event is triggered while scrolling down the filtered records.
   * @description on Scroll fetches next page data(100 records) 
  */
  loadDataOnScroll(event: LazyLoadEvent) {
    if (this.searchDate == null || this.searchDate == undefined || this.searchDate === "") {
      return;
    }

    console.log(event);
    console.log("first: " + event.first + " Rows: " + event.rows + " Page: " + (event.first / 100));
    this.pageNo = event.first / 100;
    this.loading = true;
    this.searchBySampleCreationDate(this.pageNo);
  }

  /**
   * @function
   * @param carrier 
   * @description converts State enum to string.
  */
  getStateAsString(container: any): string {
    let plateState:string =  "PROCESS_NOT_STARTED";
    if (container.processStep  &&  container.processState ) {
      plateState =  container.processStep +"_"+ container.processState;
    }
    else if(container.processStep){
      plateState =  container.processStep;
    }
    else if(container.state && container.containerType == 'CARRIER'){
      plateState =  container.state;
    }
    return plateState;
  }


  /**
   * @function
   * @description called when enter is pressed on "Search by date" filter.
  */
  searchOnDateEnter(dateStr) {
    console.log("Search on date enter" + this.searchDate);
    console.log(dateStr);

    if (this.searchDate == undefined || this.searchDate == null || this.searchDate == "") {
      this.carriers = [];
      let message = { severity: 'error', summary: 'Invalid date', detail: 'Please enter date in dd.mm.yy format' };
      this._messagesService.addErrorMessage(message);
    } else {
      this.pageNo = 0;
      this.totalRecords = 0;
      this.searchBySampleCreationDate(this.pageNo);
    }
  }

  /**
   * @function callback while focusing barcode filter
  */
  onFocusBarcode() {
    this.searchDate = "";
    this.selectedStep = null;
    this.selectedState = null;
    this.selectedWellType = null;
    this.dateFilterDisable = true;
  }

  /**
   * @function callback while focusing date filter
  */
  onFocusDate() {
    this.searchBarcode = "";
    this.dateFilterDisable = false;
  }

  onReExport(container: Container) {
    console.log("onReExport needs to be implemented", this.selectedContainer);
    this._carrierSearch.reExport(this.selectedContainer).subscribe(
      result => {
        if (!result) {
          return;
        }
        let controllerFileContent = result.sequencerControllerFileContent;
        let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
        let fileName: string = this.selectedContainer.barcode + '.txt';
        saveByFileSaver(blob, fileName);
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded ABI Sequencer file' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }


  //Get Process Step definition on tab change for selected Step
  getProcessStepDetail(step: string) {

    this.getListOfPrinters();
    this.carrierStateDetails = null;

    this.carrierStatusService.getProcessStepDetails(step, this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("[Carrier Search - Sample_Reception - CS] -> " + step + "-> ", results.data);
        this.carrierStateDetails = results.data;
        if (!this.carrierStateDetails) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: results.bbApiError.title, detail: results.bbApiError.message });
        } else {
          if (this.carrierStateDetails.printer.active)
            this.selectedPrinter = this.carrierStateDetails.printer;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }


  //Get list of active printers for selected lab
  getListOfPrinters() {
    this.carrierStatusService.getPrintersList(this.selectedLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("[Carrier Search] Printers List -> ", results.data);
        this.printersList = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  //On Print label click, print request will be sent to print service with selected printer
  onReprint(carrier: Carrier) {
    console.log("onReprint needs to be implemented");

    let prinetreq: PrintRequest = new PrintRequest();

    prinetreq.printer = this.selectedPrinter;
    prinetreq.barCode.push(this.selectedContainer.barcode);
    prinetreq.lab = this.selectedContainer.lab;

    this._carrierSearch.reprintLabel(prinetreq).subscribe(
      result => {
        if (!result) {
          return;
        }
        this._messagesService.addSuccessMessage({ severity: 'success', summary: result.data, detail: result.data });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  closeDialog($event) {
    this.selectedContainer = null;
  }

  getDateToDisplay(container: Container) {
    return container.containerType == ContainerType.CARRIER.toString() ? container.scanDate : container.creationDate;
  }

  //Get Process Step Details for selected Lab
  getProcessStepList(){
    this.processListObjects = [];
    this.processList = [];
    // Get list of Process Steps from MDM
    this._carrierSearch.getProcessStepsByLab(this.selectedLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log('Process Steps List -> ', results.data);
        this.processListObjects = results.data;
        // loop in process Step objects
        for ( let processList  of this.processListObjects) {
          //Add to the list only when process list is enabled for the step
          if(processList){
            this.processList.push( { label : processList.name, value: processList.name});
          }
        }
      },
      error => {
        console.log(error);
        const errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      });
  }


}
